import type { NodeMock, StatePreset } from "../mock-types";

export const matchStartMock: NodeMock = {
  label: "Match Start",
  description: "Countdown before match begins",
  state: (players, teamCount) => {
    const teams: Record<number, string[]> = {};
    for (let t = 1; t <= teamCount; t++) teams[t] = [];
    players.forEach((p, i) => {
      teams[(i % teamCount) + 1].push(p.userId);
    });
    return {
      countdownStarted: true,
      countdownComplete: false,
      matchSummary: {
        teams,
        map: "Dust II",
        gameMode: "Competitive",
        server: "US-East-1",
      },
    };
  },
  config: {
    countdownSeconds: 5,
    displayMessage: "Match is starting!",
    showTeams: true,
    showMap: true,
    labels: {
      title: "Match Starting",
    },
  },
};

export const matchStartPresets: StatePreset[] = [
  {
    label: "Countdown",
    build: ({ defaultState }) => ({
      state: { ...defaultState, countdownStarted: true, countdownComplete: false },
    }),
  },
  {
    label: "Started",
    build: ({ defaultState }) => ({
      state: { ...defaultState, countdownStarted: true, countdownComplete: true },
    }),
  },
];
